// src/data/portfolioData.js
export const portfolioItems = [
  {
    id: 1,
    title: "App Redesign",
    slug: "app-redesign",
    client: "Aurora Tech",
    category: "Brand Identity",
    year: "2025",
    role: ["App Design", "UI/UX"],
    description: "Aurora Tech, a rapidly growing tech company, approached me to redefine their brand identity and completely redesign their website. The goal was to modernize their digital presence to better reflect their innovative solutions while creating a seamless and engaging user experience.",
    task: "Transform brand identity with a cohesive brand refresh and a cutting-edge website redesign to drive innovation and engagement.",
    images: [
      "/assets/img/case-1.webp",
      "/assets/img/case-2.webp",
      "/assets/img/case-3.webp"
    ],
    tags: ["app design", "ui ux"]
  },
  {
    id: 2,
    title: "Revitalizing a Classic Brand",
    slug: "revitalizing-classic-brand",
    client: "Heritage Inc.",
    category: "Brand Refresh",
    year: "2024",
    role: ["Branding"],
    description: "Heritage Inc. needed to maintain their established brand equity while modernizing for today's digital landscape. My approach focused on preserving their core identity while introducing contemporary elements.",
    task: "Evolve a legacy brand with 50+ years of history into a modern digital presence without losing brand recognition.",
    images: [
      "/assets/img/case-2.webp",
      "/assets/img/case-3.webp",
      "/assets/img/case-4.webp"
    ],
    tags: ["branding"]
  },
  // Add more portfolio items
];